(ns common.resource.adserver-account-configuration
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(def collection-url (:api/advertiser-adserver-account-configurations url-tpl/templates))
(def instance-url (:api/advertiser-adserver-account-configuration url-tpl/templates))

(rf/reg-event-fx :resource.adserver-account-configuration/post
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ payload]]
    {:db (assoc db :resource.adserver-account-configuration/post {:state :pending})
     :http
     {:method :post
      :uri (url-tpl/render collection-url url-context)
      :params payload
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account-configuration/post-success]
      :on-failure [:resource.adserver-account-configuration/post-failure]}}))

(rf/reg-event-db :resource.adserver-account-configuration/post-success
  (fn [db _]
    (assoc db :resource.adserver-account-configuration/post {:state :success})))

(rf/reg-event-db :resource.adserver-account-configuration/post-failure
  (fn [db _]
    (assoc db :resource.adserver-account-configuration/post {:state :failure})))

(rf/reg-event-fx :resource.adserver-account-configuration/patch
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id payload]]
    {:db (assoc db :resource.adserver-account-configuration/patch {:state :pending})
     :http
     {:method :patch
      :uri (url-tpl/render instance-url (assoc url-context :id id))
      :params payload
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account-configuration/patch-success]
      :on-failure [:resource.adserver-account-configuration/patch-failure]}}))

(rf/reg-event-db :resource.adserver-account-configuration/patch-success
  (fn [db _]
    (assoc db :resource.adserver-account-configuration/patch {:state :success})))

(rf/reg-event-db :resource.adserver-account-configuration/patch-failure
  (fn [db _]
    (assoc db :resource.adserver-account-configuration/patch {:state :failure})))

(rf/reg-event-fx :resource.adserver-account-configuration/delete
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ id]]
    {:db (assoc db :resource.adserver-account-configuration/delete {:state :pending})
     :http
     {:method :delete
      :uri (url-tpl/render instance-url (assoc url-context :id id))
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.adserver-account-configuration/delete-success]
      :on-failure [:resource.adserver-account-configuration/delete-failure]}}))

(rf/reg-event-db :resource.adserver-account-configuration/delete-success
  (fn [db _]
    (assoc db :resource.adserver-account-configuration/delete {:state :success})))

(rf/reg-event-db :resource.adserver-account-configuration/delete-failure
  (fn [db _]
    (assoc db :resource.adserver-account-configuration/delete {:state :failure})))
